export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        perm: "view_dashboard",
        link: "/"
    },
    {
        label: "Admitted Student",
        perm: "admitted_students",
        icon: "mdi mdi-ticket-account",
        link: "/admittedstudents",
    },
    {
        label: "Register Student",
        perm: "register_student",
        icon: "mdi mdi-clipboard-account",
        link: "/newstudent",
    },
    {
        label: "Registered Students",
        perm: "registered_student",
        icon: "mdi mdi-account-multiple",
        link: "/viewstudents",
    },
    {
        label: "Migrate Students",
        perm: "migrate_student",
        icon: "mdi mdi-account-switch",
        link: "/migrate",
    },
    {
        label: "Students Parents",
        perm: "student_parents",
        icon: "mdi mdi-account-multiple",
        link: "/viewparents",
    },
    {
        label: "Staff Members",
        perm: "staff_members",
        icon: "mdi mdi-account-settings",
        link: "/staffmembers",
    },
    {
        label: "System Users",
        perm: "system_users",
        icon: "mdi mdi-account-edit",
        link: "/users",
    },
    {
        label: "School Classes",
        perm: "school_classes",
        icon: "mdi mdi-account-check",
        link: "/schoolclasses",
    },
    {
        label: "School Terms",
        perm: "school_terms",
        icon: "mdi mdi-format-float-left",
        link: "/schoolterms",
    },
];